
<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="12" md="9">
        <v-text-field v-model="address.zip" :readonly="read_only" @input="setCEP()" :rules="required" 
        label="CEP" v-mask="'##.###-###'" prepend-icon="mdi-map"></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field v-model="address.state" :readonly="read_only" :rules="required" 
        label="Estado (UF)" v-mask="'AA'" prepend-icon="mdi-map-legend"></v-text-field>
      </v-col>
      <v-col cols="12" md="9">
        <v-text-field v-model="address.addr" :readonly="read_only" :rules="required" 
        label="Rua / Avenida" prepend-icon="mdi-sign-direction"></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field v-model="address.number" :readonly="read_only" :rules="required" 
        label="Número" prepend-icon="mdi-numeric"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field v-model="address.neighborhood" :readonly="read_only" :rules="required" 
        label="Bairro" prepend-icon="mdi-map-marker"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field v-model="address.city" :readonly="read_only" :rules="required" 
          label="Cidade" prepend-icon="mdi-city"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field v-model="address.complement" :readonly="read_only" 
          label="Complemento" prepend-icon="mdi-package"></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>


<script>
import validations from '@/mixins/validations.js'
import getters from '@/_backoffice/_registrations/mixins/getters.js'

export default {
  name: 'AddressForm',
  mixins: [ validations, getters ],
  props:{
    address:{
      required: true,
      type: Object,
    },
    read_only:{
      type: Boolean,
      default: false,
    }
  },
  methods:{
    validate(){
      return this.$refs.form.validate()
    },
    setCEP() {
      if (this.address.zip.length >= 10 && !this.read_only) {
        this.getCEP(this.address.zip).then(endereco => {
          this.$set(this.address, 'addr', endereco.logradouro);
          this.$set(this.address, 'neighborhood', endereco.bairro);
          this.$set(this.address, 'city', endereco.localidade);
          this.$set(this.address, 'state', endereco.uf);
        });
      }
    },

  },
}
</script>
